import { Box, Skeleton, Stack, Grid, Paper } from "@mui/material";
import React from "react";

const DashboardSkeletonMobile = () => {
  return (
    <Box sx={{ p: 2 }}>
      {/* Header Skeleton */}
      {/* <Stack spacing={1} sx={{ mb: 3 }}>
        <Skeleton animation="wave" width="70%" height={28} />
        <Skeleton animation="wave" width="50%" height={16} />
      </Stack> */}

      {/* KPI Cards */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {[...Array(4)].map((_, i) => (
          <Grid item xs={6} key={i}>
            <Paper sx={{ p: 2, textAlign: "center" }}>
              <Skeleton animation="wave" width="80%" height={16} sx={{ mx: "auto", mb: 1 }} />
              <Skeleton animation="wave" width="70%" height={24} sx={{ mx: "auto" }} />
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Filter Dropdown */}
      <Skeleton animation="wave" width={120} height={36} sx={{ mb: 2 }} />

      {/* Charts */}
      <Stack spacing={2}>
        {/* Area Chart */}
        <Paper sx={{ p: 2 }}>
          <Skeleton animation="wave" width="100%" height={200} sx={{ borderRadius: 1 }} />
        </Paper>

        {/* Progress Bar */}
        <Paper sx={{ p: 2 }}>
          <Skeleton animation="wave" width="80%" height={16} sx={{ mb: 1 }} />
          <Skeleton animation="wave" width="100%" height={8} sx={{ borderRadius: 1 }} />
        </Paper>

        {/* Heat Map */}
        <Paper sx={{ p: 2 }}>
          <Skeleton animation="wave" width="100%" height={150} sx={{ borderRadius: 1 }} />
        </Paper>

        {/* Donut Chart */}
        <Paper sx={{ p: 2, textAlign: "center" }}>
          <Skeleton 
            animation="wave" 
            variant="circular" 
            width={120} 
            height={120} 
            sx={{ mx: "auto", mb: 1 }} 
          />
          <Skeleton animation="wave" width="70%" height={16} sx={{ mx: "auto" }} />
        </Paper>

        {/* Bar Chart */}
        <Paper sx={{ p: 2 }}>
          <Skeleton animation="wave" width="100%" height={150} sx={{ borderRadius: 1 }} />
        </Paper>

        {/* Footer Logo */}
        <Paper sx={{ p: 2, textAlign: "center" }}>
          <Skeleton 
            animation="wave" 
            variant="rectangular" 
            width={120} 
            height={120} 
            sx={{ mx: "auto", mb: 1, borderRadius: 1 }} 
          />
          <Skeleton animation="wave" width="80%" height={16} sx={{ mx: "auto", mb: 1 }} />
          <Skeleton animation="wave" width="80%" height={16} sx={{ mx: "auto" }} />
        </Paper>
      </Stack>
    </Box>
  );
};

export default DashboardSkeletonMobile;
